import Folder from '../../src/legacy/Folder';
export default Folder;
